import { DateTime } from 'litepicker/dist/types/datetime'
import { callAjax } from '../../../../assets/js/helpers'

class Cart {
  async addToCart(dateStart: DateTime, dateEnd: DateTime) {
    const formData = new FormData()

    formData.append('nonce', `${jsData.nonce}`)
    formData.append('action', 'addToCart')
    formData.append('product_id', `${jsData.post_id}`)
    formData.append('booked_date_start', dateStart.format('YYYY-MM-DD'))
    formData.append('booked_date_end', dateEnd.format('YYYY-MM-DD'))

    return callAjax({
      method: 'POST',
      body: formData,
    }).then(res => res.json()).then(e => {
      if(Array.isArray(e.data)){
        window.location.reload(true)
      } else {
        return e;
      }
    })
  }

  async getCartFragment() {
    const formData = new FormData()

    formData.append('nonce', `${jsData.nonce}`)
    formData.append('action', 'getCartFragment')
    formData.append('product_id', `${jsData.post_id}`)

    return callAjax({
      method: 'POST',
      body: formData,
    }).then(res => res.json()).then(e => {
      if(Array.isArray(e.data)){
        window.location.reload(true)
      } else {
        return e;
      }
    })
  }
}

export default Cart
